module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SAmerican Lighting","short_name":"American Lighting","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"405a8632094047c87246f9b2b64b9886"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
